import React from "react";
import styles from "./layoutCard.module.scss";
import Image from "next/image";

const LayoutCard = (props: any) => {
    return (
        <div className={styles["ai-card"]}>
            {/* Render the Image component only if the image prop exists */}
            {props.image && (
                <Image
                    height={50}
                    width={50}
                    alt={`feature-icon-${props.heading}`}
                    src={props.image}
                    className={styles["logo"]}
                />
            )}
            <h2>{props.heading}</h2>
            <p>{props.subHeading}</p>

            <ul className={styles["list"]}>
                {props.list.map((item: any, index: number) => (
                    <li key={`feature-${index}`} className={styles["list-item"]}>
                        <img
                            src="features-icon2.webp"
                            alt="icon1"
                            style={{ width: 15, height: 15, marginTop: 6 }}
                        />
                        <p className={styles["list-item-text"]}>{item}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default LayoutCard;
